module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2AQMAAAC2i/ieAAAABlBMVEVHcEwiIiLWMREbAAAAAXRSTlMAQObYZgAAABxJREFUGNNjYMAN/gxmWv4/CDwgmh7s/sFCYwMAC3xNNaM9EqsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/ico_evoucher_plus_on.png
// module id = mU5S
// module chunks = 0